import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Button, type TDefaultButtonProps } from '@/src/elements/button/default'
import { Icon } from '@/src/elements/media/Icon'
import { Typography } from '@/src/elements/text/Typography'

import type { ICON } from '../enums/icons'

type TEmptyStateProps = {
  icon?: ICON
  title?: ReactNode
  description?: ReactNode
  button?: TDefaultButtonProps
}

export const EmptyState = ({ button, description, icon, title }: TEmptyStateProps) => (
  <View className="w-full px-2 md:max-w-screen-md md:px-5 mx-auto">
    <View className="rounded-xl p-4 gap-2 items-center bg-default-bg-light mix-blend-multiply">
      {icon && <Icon name={icon} className="text-default-text-contrast-low" />}
      {title && (
        <Typography center bold size="lg" colors="default" contrast="low">
          {title}
        </Typography>
      )}
      {description && <Typography center>{description}</Typography>}
      {button && <Button {...button} />}
    </View>
  </View>
)
